import { getDocumentsAu, REGULATOR_TO_DOCS } from 'constants/documents';
import { getRegulatorForUnauthUser } from './regulators';

const getDocuments = (props) => {
  const { userRegulator, ipCountry, routingHub } = props;
  if (userRegulator && REGULATOR_TO_DOCS[userRegulator]) {
    return REGULATOR_TO_DOCS[userRegulator](props);
  }
  // use routingHub only if there is no userRegulator
  const regulator = getRegulatorForUnauthUser(routingHub, ipCountry);
  if (regulator && REGULATOR_TO_DOCS[regulator]) {
    return REGULATOR_TO_DOCS[regulator](props);
  }

  return getDocumentsAu(props);
};

export default getDocuments;
